import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f98c1a80&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=f98c1a80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98c1a80",
  null
  
)

export default component.exports